<template>

	<el-drawer
		id="activityLog"
		class="log-drawer"
		:visible.sync="visible"
		:before-close="onClose"
		size="500px"
		title="审批日志"
		:show-close="true"
		@open="opened = true"
		direction="rtl"
		:append-to-body = "true">
		<el-timeline>
			<el-timeline-item
				v-if="data && Object.keys(data).length || getActivityDetail && Object.keys(getActivityDetail).length"
				:timestamp="$options.filters.fullTime(data.createtime || getActivityDetail.details.createtime)"
				placement="top"
			>
				<div>申请人</div>
				<div class="shop-center">
					<span>{{ data.creatusername || getActivityDetail.details.shop_name }}</span>
					<Shopname
						v-if="getUserLoginType !== 'DEALER'"
						style="margin-left: 10px"
						:platform="isMyActivity ? getActivityInfoDetail.details.platform_code : getActivityDetail.details.platform_code"
					/>
				</div>
			</el-timeline-item>
			<template v-if="JSON.stringify(this.data) !== '{}'">
				<el-timeline-item
					v-for="(item, index) in data.childList"
					:key="index"
					:timestamp="item.result ? $options.filters.fullTime(item.updatetime) : ''"
					placement="top">
					<el-card :body-style="{ padding: '0px' }">
						<el-form label-width="80px" class="log-form-item">
							<el-form-item :label="item.cc ? '抄送状态' : '审批状态'">
								<ActivityLogState :state="item.result" :currentItem="item" :data="data"/>
							</el-form-item>
							<el-form-item :label="item.cc ? '抄送人' : '审批人'">
								<el-row>
									<!-- 未审批 -->
									<template v-if="!item.result">
										<template v-if="item.cc">
											<el-col v-for="(person, p) in item.ccusername.split(',')" :key="index + p" :span="8">
												{{ person }}
											</el-col>
										</template>
										<template v-if="item.approvaluseid">
											<el-col v-for="(person, p) in item.approvalusename.split(',')" :key="index + p" :span="8">
												{{ person }}
											</el-col>
										</template>
									</template>
									<!-- <span v-else-if="item.result === '3'">{{ item.approvalusename }}</span> -->
									<el-row v-else type="flex" justify="space-between" style="padding-right: 10px">
										<span>{{ item.responname }}</span>
										<template v-if="item.othername">
											<el-popover
												placement="bottom"
												width="200"
												trigger="hover">
												<el-row>
													<el-col v-for="(other, kk) in item.othername.split(',')" :key="kk + index + 1" :span="12">
														{{ other }}
													</el-col>
												</el-row>
												<span class="otherPeople" slot="reference">其他审批人</span>
											</el-popover>
										</template>
									</el-row>
								</el-row>
							</el-form-item>
							<el-form-item v-if="item.view" label="审批意见">
								<span>{{ item.view }}</span>
							</el-form-item>
						</el-form>
					</el-card>
				</el-timeline-item>
			</template>
			<template v-if="motherData && motherData.examineUsername">
				<el-timeline-item
					:timestamp="$options.filters.fullTime(motherData.updatetime)"
					placement="top">
					<el-card :body-style="{ padding: '0px' }">
						<el-form label-width="90px" class="log-form-item">
							<el-form-item label="母账号名称">
								<span>{{ motherData.examineUsername }}</span>
								<ActivityLogState :isMotherType="true" :state="motherData.examineResult"/>
							</el-form-item>
							<el-form-item label="审批意见">
								<span>{{ motherData.examineView }}</span>
							</el-form-item>
						</el-form>
					</el-card>
				</el-timeline-item>
			</template>
			<el-timeline-item v-if="opened && data.status !== '1' && JSON.stringify(this.data) !== '{}'">
				本条已<span :style="getTotalState() === '通过' ? 'color: rgb(12, 189, 12)' : 'color: #faad14'">{{ getTotalState()  }}</span>
			</el-timeline-item>
			<el-timeline-item v-if="motherData && motherData.examineResult">
				本条已<span :style="motherData.examineResult === '1' ? 'color: rgb(12, 189, 12)' : 'color: #faad14'">{{ motherData.examineResult === '1' ? '通过' : '驳回' }}</span>
			</el-timeline-item>
		</el-timeline>
	</el-drawer>
</template>

<script>
import ActivityLogState from './activityLogState'
import Shopname from 'components/shopname/Shopname'
import { mapActions, mapGetters } from 'vuex';
export default {
	name: 'activityLog',

	components:{
		Shopname,
		ActivityLogState
	},

	props: {
		isMyActivity: {
			type: Boolean,
			default: false
		},
		visible: {
			type: Boolean,
			default: false
		},
		data: {
			type: Object
		},
		motherData: {
			type: Object
		}
	},

	data () {
		return {
			opened: false,
		}
	},

	methods: {
		getTotalState() {
			const list = this.data.childList;
			let finalResult = list[list.length - 1].result;
			if(finalResult !== '1' && finalResult !== '2') {
				finalResult = list[list.length - 2].result;
			}
			return finalResult === '1' ? '通过' : '驳回'
		},
		getApprovalState(result) {
			return !result ? 0 : result === '1' ? 1 : result === '2' ? 2 : 3;
		},
		onClose() {
			this.$emit('on-close')
		}
	},

	computed: {
		...mapGetters([
			'getUserLoginType',
			'getActivityDetail',
			'getActivityInfoDetail'
		])
	},

	mounted(){
		// console.log(this.getActivityDetail);
		// console.log(this.data);
		// console.log(this.motherData);

	}
}
</script>

<style lang="scss">
#activityLog {
	.shop-center {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.log-drawer {
		.el-drawer .el-drawer__body {
			padding: 0 20px 20px 0;
		}
	}

	.log-form-item .el-form-item {
		margin-bottom: 0;
	}

	.otherPeople {
		color: #409EFF;
		cursor: pointer;
	}
}
</style>
